import { ErrorBoundary } from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import type { RoutesFunc } from 'src/routes/routes';

import { ProfiledApp } from './app';
import { UnexpectedError } from './components/unexpected-error';

export function loadReactApp(routes: RoutesFunc) {
  const root = document.getElementById('react-root');
  if (!root) {
    throw new Error('react-root element not found');
  }
  const reactRoot = createRoot(root);
  reactRoot.render(
    <StrictMode>
      <ErrorBoundary fallback={<UnexpectedError />}>
        <ProfiledApp routes={routes} />
      </ErrorBoundary>
    </StrictMode>,
  );
}
